import { RandomUtils } from "@dooboostore/core";
import { AlertAction } from "./AlertAction.js";
class Alert {
  constructor(alertService, config) {
    this.alertService = alertService;
    this.config = config;
    this.isActive = false;
    this.activateBefore = [];
    this.activateAfter = [];
    this.deActivateBefore = [];
    this.deActivateAfter = [];
    this.data = /* @__PURE__ */ new Map();
    if (config?.uuid) {
      this.uuid = config.uuid;
    } else {
      this.uuid = RandomUtils.uuid();
    }
  }
  addOpenBefore(fn) {
    this.activateBefore.push(fn);
  }
  addOpenAfter(fn) {
    this.activateAfter.push(fn);
  }
  addCloseBefore(fn) {
    this.deActivateBefore.push(fn);
  }
  addCloseAfter(fn) {
    this.deActivateAfter.push(fn);
  }
  setData(key, value) {
    this.data.set(key, value);
  }
  getData(key) {
    return this.data.get(key);
  }
  async activate() {
    try {
      await Promise.allSettled(this.activateBefore.map((it) => it())).then((it) => {
        this.result = this.make();
        this.alertService?.publish({ action: AlertAction.ACTIVE, alert: this });
        this.isActive = true;
        if (this.config?.closeTime !== void 0 && this.config?.closeTime > 0) {
          setTimeout(() => {
            this.deActivate();
          }, this.config.closeTime);
        }
        this.config?.activate?.(this.result, this);
      });
    } catch (e) {
    } finally {
      await Promise.allSettled(this.activateAfter.map((it) => it())).then((it) => {
      });
    }
  }
  async deActivate() {
    try {
      await Promise.allSettled(this.deActivateBefore.map((it) => it())).then((it) => {
        this.alertService?.publish({ action: AlertAction.IN_ACTIVE, alert: this });
        this.isActive = false;
        this.config?.deActivate?.(this.result, this);
      });
    } catch (e) {
    } finally {
      await Promise.allSettled(this.deActivateAfter.map((it) => it())).then((it) => {
      });
    }
  }
}
export {
  Alert
};
//# sourceMappingURL=Alert.js.map
